<template>
  <div class="iv-remote-wrapper">
    <Tree
      :data="data"
      @on-select-change="handleSelectChange"
      disableCheckbox></Tree>
  </div>
</template>
<script>
import {BFS} from '@/utils'
export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    url: {
      type: String,
      default: 'api-general/module/portal/user/outGetRadioList'
    },
    map: {
      type: Object,
      default () {
        return {
          title: 'title',
          value: 'value'
        }
      }
    },
    params: {
      type: Object,
      default () {
        return {}
      }
    },
    method: {
      type: String,
      default: 'GET'
    }
  },
  data () {
    return {
      data: [],
      loading: false
    }
  },
  created () {
    this.remoteMethod()
  },
  watch: {
    value (val) {
      // initial selct tree data
      this.initSelectData()
    }
  },
  methods: {
    BFS,
    handleSelectChange (data) {
      this.$emit('on-select-change', data, this.data)
    },
    remoteMethod (query) {
      if (!this.url) return
      this.$ajax({
        url: this.url,
        method: this.method,
        data: this.params
      }).then(({data}) => {
        this.data = data.data
        this.initSelectData()
        this.$emit('on-list', data.data)
      })
    },
    onChang (val) {
      this.$emit('input', val)
      this.$emit('on-change', val)
    },
    initSelectData () {
      let value = Array.isArray(this.value) ? this.value : [this.value]
      this.BFS(this.data, (item) => {
        if (value.includes(this.getId(item))) {
          item.selected = true
          this.$emit('on-select', item)
        }
        if (item.selected && !value.includes(this.getId(item))) {
          item.selected = false
        }
      })
    },
    getId (item) {
      return item?.data?.itemCode
    }
  }
}
</script>
<style lang="scss">
.iv-remote-wrapper{
  .ivu-select-input{
    height: 32px !important;
    line-height: 32px !important;
  }
}
</style>
